import {ActivityIndicator}  from 'react-native';

import cores from '../util/cores'



export function carregamento(sincronizando) {
													
																									
    return(
		<ActivityIndicator 
			style={{justifyContent: 'center',
					alignItems:'center',
					flex:1}} 
			size={50} 
			color={cores.azul} 
			animating={sincronizando}/>
	)  
} 



